import { z } from 'zod';
import {
    type ControlSocketKind,
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const activatePickLightCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('activatePickLight'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
    })),
}));
interface ActivatePickLightCfgSchema extends z.infer<typeof activatePickLightCfgSchema> {}

export const activatePickLightSocketCfg = {
    controlSockets: {
        outputs: () => ({}),
        inputs: () => {
            const ret: Record<'activate', ControlSocketKind> = {
                activate: 'event',
            };
            return ret;
        },
    },
    dataSockets: {
        outputs: () => ({}),
        inputs: () => {
            const ret: {
                color: 'string';
                display: 'number';
                animation: 'string';
                pickLightId: 'number';
                channelNumber: 'number';
            } = {
                color: 'string',
                display: 'number',
                animation: 'string',
                pickLightId: 'number',
                channelNumber: 'number',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<ActivatePickLightCfgSchema>;
